import { render, staticRenderFns } from "./ThreeDSModal.vue?vue&type=template&id=651efb56&"
import script from "./ThreeDSModal.vue?vue&type=script&lang=js&"
export * from "./ThreeDSModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports